// extracted by mini-css-extract-plugin
export default {"icon":"style_icon__Ip0M+","member":"style_member__fMM56"};